<script setup>
import { computed }  from 'vue'
import { useTranslaterStore }   from '@/stores/translater'
import { useProfileStore }      from '@/stores/profile'
import checkArrayIncludes       from '@/helpers/checkArrayIncludes'

function scrollToTop() {
    document.documentElement.scrollTop ? 
        document.documentElement.scrollTop = 0 : 
        document.body.scrollTop = 0
}

const translaterStore = useTranslaterStore()
const profileStore = useProfileStore()

const getTranslate = computed(() => translaterStore.getTranslate)
const profile = computed(() => profileStore.profile)

</script>

<template>
    <div class="uta-footer">
        <div class="uta-footer__copyright">
            {{ getTranslate.FOOTER_COPYRIGHT }}
            <RouterLink to="/certificates" class="uta-footer__cert" v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN', 'CERTIFICATE_ADMIN'])">
                <span class="material-icons uta-footer__cert-icon">gpp_good</span>
            </RouterLink>
        </div>
        <div class="uta-footer__contacts">
            <a class="uta-footer__contacts-email" href="mailto:support.app@nami.ru">
                <div class="uta-footer__contacts-phone-icon">
                    <span class="material-symbols-outlined">mail</span>
                </div>
                <div class="uta-footer__contacts-phone-text">
                    support.app@nami.ru
                </div>
            </a>
        </div>
        <div class="uta-footer__gotop" @click="scrollToTop()">
            <div class="uta-footer__gotop-icon">
                <span class="material-symbols-outlined">chevron_left</span>
            </div>
            <div class="uta-footer__gotop-text">
                {{ getTranslate.FOOTER_GOTOP }}
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/footer.scss';
</style>